import { Component, OnInit, ViewChild } from "@angular/core";
import { Location } from "@angular/common";
import { ActivatedRoute } from "@angular/router";
import { AuthService } from "src/app/auth.service";
import { DataServiceService } from "src/app/data-service.service";
import { User } from "src/app/model/login";
import { getSourceByField, SourceItem } from 'src/app/utils/source-utils';
import { HttpClient } from '@angular/common/http';
import * as moment from "moment";
import { ResultCriminalComponent } from "../result-criminal/result-criminal.component";
import { NewPrintBodyComponent } from "./new-print-body/new-print-body.component";

@Component({
  selector: 'app-new-print',
  templateUrl: './new-print.component.html',
  styleUrls: ['./new-print.component.scss']
})
export class NewPrintComponent implements OnInit {
  @ViewChild(NewPrintBodyComponent) printBodyComponent: NewPrintBodyComponent;

  constructor(
    private route: ActivatedRoute,
    private dataService: DataServiceService,
    private authService: AuthService,
    private http: HttpClient,
    private location: Location
  ) {}

  ngOnInit(): void {}

  goBack() {
    localStorage.setItem("skipSearchOnBack", "true");
    localStorage.setItem("skipSearchOnBackTs", Date.now().toString());
    this.location.back();
  }

  savePageRecord() {
    this.callChildComponentMethod()
  }

  callChildComponentMethod() {
    if (this.printBodyComponent) {
      this.printBodyComponent.saveRecord();
    }
  }
} 